import { render, staticRenderFns } from "./radioHospital.vue?vue&type=template&id=1db97676&scoped=true&"
import script from "./radioHospital.vue?vue&type=script&lang=js&"
export * from "./radioHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db97676",
  null
  
)

export default component.exports